export type SearchParamUpdate = Record<string, string | null | undefined>

type HistoryMode = 'push' | 'replace'

function getSearchParams(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams()
  return new URLSearchParams(window.location.search)
}

export function readSearchParam(key: string): string | undefined {
  const value = getSearchParams().get(key)
  return value?.trim() || undefined
}

export function readAllowedSearchParam<T extends string>(
  key: string,
  allowedValues: readonly T[],
  fallback: T,
): T {
  const value = readSearchParam(key)
  return value && (allowedValues as readonly string[]).includes(value)
    ? (value as T)
    : fallback
}

export function updateSearchParams(
  updates: SearchParamUpdate,
  mode: HistoryMode = 'replace',
): void {
  if (typeof window === 'undefined') return

  const params = getSearchParams()
  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      params.delete(key)
      return
    }
    params.set(key, value)
  })

  const search = params.toString()
  const nextUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`

  if (nextUrl === currentUrl) return
  window.history[`${mode}State`](window.history.state, '', nextUrl)
}

export function replaceSearchParams(updates: SearchParamUpdate): void {
  updateSearchParams(updates, 'replace')
}

export function pushSearchParams(updates: SearchParamUpdate): void {
  updateSearchParams(updates, 'push')
}
